import { useState, useEffect, useContext } from "react";
import { useHttpClient } from "shared/hooks/http-hook";
import { useTranslation } from "react-i18next";
import { AuthContext } from "shared/context/auth-context";

export const useTransportTypeSetup = (token, client, clientId) => {
  const { sendRequest } = useHttpClient();
  const { t } = useTranslation();
  const auth = useContext(AuthContext);
  const [showTransportTypeModal, setShowTransportTypeModal] = useState(false);
  const [showSeedDataModal, setShowSeedDataModal] = useState(false);
  const [selectedTransportType, setSelectedTransportType] = useState(null);
  const [isTransportTypeLoading, setIsTransportTypeLoading] = useState(false);
  const [isSeedDataLoading, setIsSeedDataLoading] = useState(false);

  // Check if user needs to complete transport type setup
  useEffect(() => {
    if (token && client?.onboardingStatus && !client.onboardingStatus.finishedMetaSetup) {
      setShowTransportTypeModal(true);
    }
  }, [token, client]);

  const handleTransportTypeSelect = async (selectedType) => {
    setIsTransportTypeLoading(true);
    try {
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/clients/${clientId}/transport-type`,
        "PATCH",
        JSON.stringify({ transportType: selectedType }),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      );

      setShowTransportTypeModal(false);
      setSelectedTransportType(selectedType);
      //window.toast.success(t("transportType.savedSuccessfully"));

      // Show seed data confirmation modal for non-demo accounts
      // Demo accounts skip this and reload immediately to apply new permissions
      if (auth.company.isDemo) {
        setShowSeedDataModal(false);
        window.location.reload();
        // Reload page to apply new permissions and load data
        // setTimeout(() => {
        //   window.location.reload();
        // }, 500);
      } else {
        setShowSeedDataModal(true);
      }
    } catch (err) {
      window.toast?.error?.("Failed to save transport type. Please try again.");
    } finally {
      setIsTransportTypeLoading(false);
    }
  };

  const handleSeedDataAccept = async () => {
    setIsSeedDataLoading(true);
    try {
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/clients/${clientId}/seed-sample-data`,
        "POST",
        JSON.stringify({ transportType: selectedTransportType }),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      );

      window.toast.success(t("seedData.success"));
      setShowSeedDataModal(false);

      // Refresh page to show new data
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (err) {
      window.toast.error(t("seedData.error"));
      setShowSeedDataModal(false);
    } finally {
      setIsSeedDataLoading(false);
    }
  };

  const handleSeedDataSkip = () => {
    setShowSeedDataModal(false);
    window.toast.info(t("seedData.skipped"));

    // Refresh page
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  return {
    showTransportTypeModal,
    showSeedDataModal,
    selectedTransportType,
    isTransportTypeLoading,
    isSeedDataLoading,
    handleTransportTypeSelect,
    handleSeedDataAccept,
    handleSeedDataSkip,
  };
};
